





























































































































import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
import { IDialog, User, IDialogValue } from '@models';

@Component
export default class PopupDialog extends Vue {
  name = 'popupDialog';
  @Prop({ type: Object as () => IDialog })
  public dialogModel!: IDialog

  changeSelection(value: IDialogValue) {
    value.customValidation();
    value.displayChange();
  }
  checked: boolean = true;

  fixString(val) {
    if (val.id =='thirdPartyTagOriginal')
      this.dialogModel.fixString(this.checked);
  }
  fixStringChecked() {
    this.dialogModel.fixString(this.checked);
  }
  submit() {
    var form = this.$refs[this.dialogModel.formRef] as Vue & { validate: () => boolean };
    if (form.validate()) {
      this.dialogModel.ok();
    }
  }

  close() {
    var form = this.$refs[this.dialogModel.formRef] as Vue & { validate: () => boolean };
    if (form.validate()) {
      this.dialogModel.close();
    }
  }

  cancel() {
    this.dialogModel.visible = false;
  }

  formCleanUp() {
    if (!this.dialogModel.useTextArea) {
      var form = this.$refs[this.dialogModel.formRef] as Vue & { reset: () => void };
      form.reset();
    }
  }

  //Fix error: When clicking outside dialog, the cancel function is not called.
  @Watch('dialogModel.visible')
  visibleChanged(value: boolean, oldValue: boolean) {
    if (oldValue === true && value === false ) {
      this.formCleanUp();
      this.dialogModel.cancel();
    }
  }

  @Watch('dialogModel.metaInformation.userSearchString', { immediate: false })
  userSearchChanged(value: any, oldValue: any) {
    if (value) {
      setTimeout(async () => {
        if (!this.dialogModel.metaInformation.searchingForUsers) {
          this.dialogModel.metaInformation.searchingForUsers = true;

          var dublicateFreeItems: User[] = [];

          if (this.dialogModel.metaInformation.userSearchString) {
            var searchItems = await this.dialogModel.metaInformation.searchUsers(this.dialogModel.metaInformation.userSearchString);

            for (var i = 0; i < searchItems.length; i++) {
              var dublicate = false;
              for (var j = 0; j < this.dialogModel.metaInformation.userIds.length; j++) {
                if (this.dialogModel.metaInformation.userIds[j] === searchItems[i].id) {
                  dublicate = true;
                  break;
                }
              }

              if (!dublicate) {
                dublicateFreeItems.push(searchItems[i]);
              }
            }
          }

          this.dialogModel.metaInformation.userSearchItems = dublicateFreeItems;
          this.dialogModel.metaInformation.searchingForUsers = false;
        }
      }, 1500)
    }
  }
}
